<template>
    <div id="vessel-view-live-camera">
      <div class="live-camera-area">
        <P>{{ cameraMsg }}</P>
        <vs-button
          v-if="hasVideoError"
          icon-pack="feather"
          icon="icon-rotate-cw"
          color="rgb(255, 255, 255)"
          type="line"
          size="small"
          @click="connect"
          class="retry-button"
          >{{ retryText }}</vs-button
        >
        <video-player
          :class="customClass"
          ref="videoPlayer"
          :options="playerOptions"
          @ready="onPlayerReadied"
          @error="onPlayerError"
        />
      </div>
    </div>
</template>

<script>
import { videoPlayer } from "vue-videojs7";
import videojs from "video.js";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { CAMERA_MOVIE_TYPE } from "@/config/const.js";

export default {
  components: {
    videoPlayer
  },
  props: {
    camera: {
      type: Object,
      required: true
    },
    numberOfCamera: {
      type: Number,
      required: false
    },
    playerWidth: {
      type: Number,
    },
    playerHeight: {
      type: Number,
    },
    customClass: {
      type: String,
      default: ""
    },
    showControlBar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    player() {
      if (typeof this.$refs.videoPlayer === "undefined") return null;
      return this.$refs.videoPlayer.player;
    }
  },
  data() {
    return {
      initialized: false,
      hasVideoError: false,
      retryText: "",
      cameraMsg: "",
      errorDisplay: null,
      playerOptions: {
        width: null,
        height: null,
        autoplay: true,
        muted: true,
        preload: "auto",
        fullscreen: false,
        bigPlayButton: false,
        flash: { hls: { withCredentials: false } },
        html5: { hls: { withCredentials: false } },
        language: "ja",
        languages: {
          ja: {
            Play: "再生",
            "The media could not be loaded, either because the server or network failed or because the format is not supported.":
              "再生できませんでした"
          }
        },
        controlBar: {
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
          playToggle: false,
          progressControl: {
            seekBar: false
          }
        }
      }
    };
  },
  watch: {
    camera: {
      immediate: true,
      handler() {
        if (this.camera) {
          this.connect();
        }
        //this.hasVideoError = false;
        //this.cameraMsg = ""
      }
    }
  },
  mounted() {
    if (!this.showControlBar) this.$refs.videoPlayer.player.controlBar.hide()
  },
  created() {
    this.playerOptions.width = this.playerWidth
    this.playerOptions.height = this.playerHeight
  },
  methods: {
    async onPlayerReadied() {
      this.setCameraSize();
      if (!this.initialized) {
        this.initialized = true;
      }
    },

    onPlayerError() {
      this.cameraMsg = "";
      this.retryText = "";
      this.hasVideoError = true;
    },

    async connectToCamera() {
      try {
        let res = await AiseaApiFactory.get("enterpriseCamera").connect(
          this.camera.id
        );
        return res.data.url;
      } catch (e) {
        return null;
      }
    },

    async connectToHlsCamera() {
      try {
        let res = await AiseaApiFactory.get("enterpriseCamera").connectHLS(
          this.camera.id
        );
        return res.data.url;
      } catch (e) {
        return null;
      }
    },

    async connect() {
      this.cameraMsg = "接続中...";

      console.log(this.camera)
      let url
      if( this.camera.movie_type === CAMERA_MOVIE_TYPE.HLS_CAMERA
        || this.camera.movie_type === CAMERA_MOVIE_TYPE.HLS_RADAR ){
        url = await this.connectToHlsCamera();
        if (url) {
          this.playVideoHls(url);
        } else {
          this.errorHandler();
        }
      } else {
        let url = await this.connectToCamera();
        if (url) {
          this.playVideo(url);
        } else {
          this.errorHandler();
        }
      }
    },

    errorHandler() {
      if (this.player) {
        this.player.reset();
        let ErrorDisplay = videojs.getComponent("ErrorDisplay");
        this.errorDisplay = new ErrorDisplay(this.player, {
          temporary: false
        });
        this.player.addChild(this.errorDisplay);
        this.cameraMsg = "";
        this.player.error("接続失敗");
        this.retryText = "";
        this.hasVideoError = true;
      }
    },

    playVideo(bassUrl) {
      if (this.player) {
        this.cameraMsg = "";
        //this.player.error(null);
        //this.errorDisplay = null
        const video = {
          withCredentials: false,
          type: "application/x-mpegurl",
          src: `${bassUrl}/webcam/hls/stream.m3u8`
        };
        this.player.src(video);
        this.player.poster(`${bassUrl}/webcam/thumbnail/thumbnail.png`);
      }
    },

    playVideoHls(bassUrl) {
      if (this.player) {
        this.cameraMsg = "";
        const video = {
          withCredentials: false,
          type: "application/x-mpegurl",
          src: bassUrl
        };
        this.player.src(video);
        let path = bassUrl.split("/")
        path.pop()
        this.player.poster(path.join("/") + "/thumbnail.png");
      }
    },

    setCameraSize() {
      this.player.width(this.playerWidth);
      this.player.height(this.playerHeight);
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
#vessel-view-live-camera {
  padding: 1px;
  .vjs-text {
    z-index: 1;
    font-size: 2em;
    line-height: 1.5em;
    height: 1.63332em;
    display: block;
    position: absolute;
    top: 10px;
    opacity: 1;
    transition: all 0.4s;
  }

  .live-camera-area {
    position: relative;
  }

  .live-camera-area p {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
    color: white;
    z-index: 5;
  }

  .retry-button {
    z-index: 5;
    position: absolute;
    top: 80%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .grid-view-item {
    .grid-view-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      transition: 0.35s;
    }

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.25);

      .grid-view-img {
        opacity: 0.9;
      }
    }
  }

  .vjs-text-track-display {
    pointer-events: auto !important;
  }
}
</style>
